import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "company-assessment-form-multiselect" }
const _hoisted_2 = {
  key: 0,
  class: "displaymode-text"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "flex-grow-1" }

import type {
	CompanyAssessmentQuestionAnswerMultiDto,
	CompanyAssessmentQuestionChoiceDto,
} from "@/dto";
import { computed } from "vue";
import { companyAssessmentInputProps } from "./companyAssessmentInputProps";
import { getTranslation } from "../companyAssessmentShared";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAssessmentFormMultiSelect',
  props: {
	modelValue: {
		type: Array as () => CompanyAssessmentQuestionAnswerMultiDto[],
		required: true,
	},
	...companyAssessmentInputProps,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedChoices = computed(() => {
	const arr = [] as CompanyAssessmentQuestionChoiceDto[];
	for (const answer of props.modelValue) {
		const choice = props.question.choices.find((c) => c.id === answer.choiceId);
		if (choice) {
			arr.push(choice);
		}
	}
	return arr;
});

const myModelValue = computed({
	get() {
		const getVal = props.modelValue.map((x) => x.choiceId);
		return getVal;
	},
	set(newValue: number[] | null) {
		const choices = props.question.choices.filter((c) => newValue?.includes(c.id) ?? false);
		const newModelValue = choices.map(
			(c) =>
				({
					choiceId: c.id,
					questionAnswerId: 0,
				} as CompanyAssessmentQuestionAnswerMultiDto)
		);

		emit("update:modelValue", newModelValue);
	},
});

const myId = computed(() => {
	return `question-${props.question.id}`;
});

function getChoiceText(choice: CompanyAssessmentQuestionChoiceDto) {
	let translation = choice.translations.find((t) => t.languageCode === props.language);

	if (!translation) {
		translation = choice.translations[0];
	}

	return translation ? translation.text : "";
}

return (_ctx: any,_cache: any) => {
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoCheckbox = _resolveComponent("HakoCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedChoices.value, (choice) => {
            return (_openBlock(), _createElementBlock("div", {
              key: choice.id
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _createVNode(_component_HakoBsIcon, { icon: "dot" })
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getTranslation)(
									choice,
									_ctx.language,
									(x) => x.translations,
									(x) => x.text
								)), 1)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.question.choices, (choice) => {
          return (_openBlock(), _createBlock(_component_HakoCheckbox, {
            key: choice.id,
            id: `${myId.value}-${choice.id}`,
            for: `${myId.value}-${choice.id}`,
            name: myId.value,
            value: choice.id,
            modelValue: myModelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((myModelValue).value = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getChoiceText(choice)), 1)
            ]),
            _: 2
          }, 1032, ["id", "for", "name", "value", "modelValue"]))
        }), 128))
  ]))
}
}

})